export enum CheckInPostEventModalResultType {
  CANCEL = 'cancel',
  LEAVE = 'leave',
}
